<template>
  <component :is="categoryData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->
    <b-alert :show="categoryData === undefined" variant="danger">
      <h4 class="alert-heading">
        Erreur de récupération des données de catégories
      </h4>
      <div class="alert-body">
        Pas de Catégorie trouvé sur cet identifiant. Vérifiez
        <b-link :to="{ name: 'apps-item-categories-list' }" class="alert-link">
          la liste des catégories
        </b-link>
        pour d'autres catégories.
      </div>
    </b-alert>

    <b-tabs v-if="categoryData" pills>
      <!-- Tab: Général -->
      <b-tab active>
        <template #title>
          <feather-icon class="mr-0 mr-sm-50" icon="UserIcon" size="16"/>
          <span class="d-none d-sm-inline">Création Catégorie</span>
        </template>
        <handle-item-category-tab-general
            :available-categories-list="parentsList"
            :category-data="categoryData"
            class="mt-2 pt-75"
            @data-handled="$router.push({ name: 'apps-item-categories-list' })"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
/* eslint-disable */
import {BAlert, BCard, BLink, BTab, BTabs} from "bootstrap-vue";
import {onMounted, ref} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import HandleItemCategoryTabGeneral from "./HandleItemCategoryTabGeneral.vue";

// Notification

export default {
  name: "HandleItemCateogries",
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    HandleItemCategoryTabGeneral,
  },
  setup() {
    const blankCategoryData = {
      name: "",
      description: "",
      parent: null,
    };
    const parentsList = ref([]);

    const categoryData = ref(JSON.parse(JSON.stringify(blankCategoryData)));
    const fetchCategory = async () => {
      try {
        const category = await store
            .dispatch("itemCategory/fetchCategory", {
              id: router.currentRoute.params.id,
            })
        if (category.parent) category.parent = category.parent?.uid;
        categoryData.value = category;
      } catch (error) {
        if (error.response?.status === 404) {
          categoryData.value = undefined;
        }
      }
    };

    onMounted(() => {
      if (router.currentRoute.params.id) {
        fetchCategory();
      }
      getParents();
    });

    const filterParentCategories = (list = []) => {
      const currentId = router.currentRoute.params.id;
      return list.filter((c) => c.is_parent && (!currentId || c.uid !== currentId));
    };

    const getParents = async () => {
      const categories = await store.dispatch("itemCategory/allCategories");
      parentsList.value = filterParentCategories(categories)
    };

    return {
      categoryData,
      parentsList,
    };
  },
};
</script>
